import orderKegCollarsSagas from './orderKegCollars'

// CODE_COMMENTS_11
export default [
  ...orderKegCollarsSagas,
]
